module.exports = "/_next/static/images/image-spaceship-times-e1ede04c4b13c3d4821b4af5128a133b.png";